export default __webpack_public_path__ + "static/media/recycle.2044fcaa.svg";